// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"761f1ed9","240":"8a0ac8d1","323":"f11917ab","529":"bc304451","787":"28cb0dcd","816":"7b654301","931":"cdc945b2"}[chunkId] + ".chunk.js";
};